import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import {
  NguCarousel,
  NguCarouselDefDirective,
  NguCarouselNextDirective,
  NguCarouselPrevDirective,
  NguItemComponent,
  NguTileComponent
} from '@ngu/carousel';
import { I18nModule, UrlModule } from "@spartacus/core";
import { FormErrorsModule, MediaModule, OutletPosition, provideOutlet } from "@spartacus/storefront";
import { LoginFormModule } from "@spartacus/user/account/components";
import { LocationStripComponent } from "src/app/shared/modules/location-strip/location-strip.component";
import { LocationStripModule } from "src/app/shared/modules/location-strip/location-strip.module";
import { ProductCarouselHomepgComponent } from "./product-carousel-homepg/product-carousel-homepg.component";


@NgModule({
  declarations: [ProductCarouselHomepgComponent],
  imports: [
    CommonModule,
    LoginFormModule,
    FormsModule,
    ReactiveFormsModule,
    UrlModule,
    I18nModule,
    FormErrorsModule,
    LocationStripModule,
    RouterModule,
    MediaModule,
    // NguCarouselModule, 
    NguCarousel, 
  NguTileComponent,   
  NguCarousel,
  NguCarouselDefDirective,
  NguCarouselNextDirective,
  NguCarouselPrevDirective,
  NguItemComponent
  ],

  providers: [
    provideOutlet({
        id: 'Section3',
        position: OutletPosition.REPLACE,
        component: ProductCarouselHomepgComponent,
      }),
    provideOutlet({
      id: 'BottomHeaderSlot',
      position: OutletPosition.AFTER,
      component: LocationStripComponent,
    })
  ],
})
export class HomeScreenModule {}
